import React from 'react';

import CompanyPage from '../../js/pages/HubPage/CompanyPage';
import {getCompanyHubData} from '../../../server/services/hub';

export default function Page(props) {
  return <CompanyPage {...props} />;
}

export async function getStaticProps({params}) {
  const results = await getCompanyHubData(params.company);
  if (!results) return {notFound: true};

  return {
    props: JSON.parse(JSON.stringify(results)), // serialize dates and drop undefineds for Next
    revalidate: 3600,
  };
}

// See https://nextjs.org/docs/api-reference/data-fetching/get-static-paths
export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking',
  };
}
